import React, { useEffect, useState } from 'react';
import TelecomBanner from '../components/TelecomBanner';
import StatsCards from '../components/Mobile';
import DevelopmentProcess from '../components/VoiceCall';
import TechServicesGrid from '../components/TechServiceGrid';
import HeroSection from '../components/CloudSloution';
import WorkingProcess from '../components/CLoudSteps';

function CloudTelecom() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);

  useEffect(() => {
    // Update isMobile state on window resize
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 600);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);


  const styles = {
    hero: {
      marginTop: isMobile ? '30px' : '40px',
      // marginBottom: isMobile ? '20px' : '20px',
    },
    hero2: {
      // marginTop: isMobile ? '-20px' : '-20px',
      marginBottom: isMobile ? '30px' : '60px',
    },
    hero3: {
      marginTop: isMobile ? '30px' : '20px',
      marginBottom: isMobile ? '30px' : '25px',
    },
    hero4: {
      marginTop: isMobile ? '50px' : '30px',
      marginBottom: isMobile ? '10px' : '5px',
    },
    hero5: {
      marginTop: isMobile ? '-50px' : '0px',
      marginBottom: isMobile ? '-40px' : '5px',
    },
  };
  return (
    <>
      <TelecomBanner />

      <div style={styles.hero3}>
        <StatsCards />

        </div>
        <div style={styles.hero2}>
        <TechServicesGrid />
   </div>
   <div style={styles.hero}>
        <DevelopmentProcess />
        </div>

        <div style={styles.hero4}>
        <WorkingProcess />

</div>
<div style={styles.hero5}>

        <HeroSection />
   </div>
    </>
  );
}

export default CloudTelecom;
